import React, { Fragment } from 'react';
import ParentAuthPage from './ParentAuthPage';
import ViewSpinner from 'components/ViewSpinner';
import styled from 'styled-components';
import UserService from 'utils/UserService';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from 'actions/AuthActions';
import * as UiActions from 'actions/UiActions';
import 'css/BetalingshistorikPage.scss';
import moment from 'moment';
import { Col, Row } from 'react-grid-system';
import DatePicker from 'features/DatePicker';
import { FullScreen } from 'ui/FullScreen';
import Wrapper from 'ui/Wrapper';
import FlexWrapper from 'ui/FlexWrapper';
import Text from 'ui/Text';
import Arrow from 'ui/Arrow';
import Icon from '../ecoui/Icon';
import calendarIcon from 'images/calendar.svg';
import Button from 'ui/Button';
import { detectMobile } from 'utils/UiHelper';
import { browserHistory, Link } from 'react-router';

const Header = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 20px 0;
    color: #404757;
`;
const TimeRange = styled.div`
    padding: 5px;
    border-radius: 5px;
    background-color: #ebeff6;
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 12px;
    color: #404757;
    height: 12px;
    cursor: pointer;
`;

const TextWrapper = styled(Wrapper)`
    font-weight: 300;
    max-width: 410px;
    line-height: 20px;
    margin: 80px auto;

    @media screen and (max-width: 475px) {
        ${Text} {
            text-align: justify;
            padding: 0 15px;
        }
    }
`;

const StyledLink = styled(Link)`
    cursor: pointer;
    color: #20486f;
    text-decoration: underline;
`;

class BetalingshistorikPage extends ParentAuthPage {
    constructor() {
        super();

        this.state = {
            data: null,
            count: 15,
            shouldShowMore: true,
            dateFrom: moment()
                .subtract(1, 'month')
                .toDate(),
            dateTo: moment().toDate(),
            datePicker: null,
            setDateMode: true,
        };
    }

    componentDidMount() {
        this.setPageTitle('Betalingshistorik');
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.auth.user && this.props.auth.sessionError) {
            browserHistory.push('/sport/');
            this.props.uiActions.showModal('LOGIN_FIRST');
        }
    }

    systemDateFormat = 'DDMMYYYY';
    uiDateFormat = 'DD MMM. YYYY';

    openDatePicker = (mode) => {
        this.setState({
            count: 15,
            datePicker: (
                <DatePicker
                    maxDate={new Date()}
                    height={detectMobile() ? null : 530}
                    width={detectMobile() ? '100%' : 640}
                    small={!!detectMobile()}
                    onDateSelected={this.onDateSelected.bind(this, mode)}
                    selectedDate={this.state[mode]}
                />
            ),
        });
    };

    onDateSelected = (mode, date) => {
        if (mode === 'dateFrom') {
            this.setState({
                dateFrom: date,
                datePicker: null,
            });
        } else {
            this.setState({
                dateTo: date,
                datePicker: null,
            });
        }
    };

    showData = () => {
        this.setState({
            setDateMode: false,
        });
        UserService.Payment(
            moment(this.state.dateFrom).format(this.systemDateFormat),
            moment(this.state.dateTo).format(this.systemDateFormat),
            0,
            this.state.count,
            (res) => {
                this.setState({
                    shouldShowMore: res.count >= this.state.count,
                    data: res && res.transactions ? res.transactions : [],
                });
            }
        );
    };

    chooseNewDate = () => {
        this.setState({
            setDateMode: true,
        });
    };
    showMore = () => {
        UserService.Payment(
            moment(this.state.dateFrom).format(this.systemDateFormat),
            moment(this.state.dateTo).format(this.systemDateFormat),
            0,
            this.state.count + 15,
            (res) => {
                this.setState({
                    shouldShowMore: res.length === this.state.count + 15,
                    count: this.state.count + 15,
                    data: res && res.transactions ? res.transactions : [],
                });
            }
        );
    };

    render() {
        const { dateFrom, dateTo, data, shouldShowMore } = this.state;
        return (
            <Fragment>
                {this.getHeaderView(() => {
                    this.props.uiActions.showModal('USER_MENU');
                })}
                <FullScreen>
                    {!detectMobile() ? (
                        <Text size="x3" block align="center">
                            Transaktioner
                        </Text>
                    ) : null}

                    <Wrapper>
                        {this.state.setDateMode ? (
                            <Wrapper>
                                <Text>VIS FRA</Text>
                                <Button
                                    radius="20px"
                                    padding="10px"
                                    style={{
                                        background: 'rgb(236, 239, 245)',
                                    }}
                                    onClick={this.openDatePicker.bind(
                                        this,
                                        'dateFrom'
                                    )}
                                    width="100%"
                                >
                                    {dateFrom ? (
                                        <Text
                                            bold
                                            color="rgb(145, 152, 170)"
                                            align="center"
                                        >
                                            {moment(dateFrom).format(
                                                this.uiDateFormat
                                            )}
                                        </Text>
                                    ) : (
                                        <FlexWrapper
                                            padding="0px"
                                            direction="row"
                                            align="space-around"
                                        >
                                            <Text>VIS FRA</Text>
                                            <Arrow
                                                block
                                                direction="down"
                                                margin="12px 10px 0px"
                                            />
                                        </FlexWrapper>
                                    )}
                                </Button>
                                <Text>VIS TIL</Text>
                                <Button
                                    radius="20px"
                                    padding="10px"
                                    style={{
                                        background: 'rgb(236, 239, 245)',
                                    }}
                                    onClick={this.openDatePicker.bind(
                                        this,
                                        'dateTo'
                                    )}
                                    width="100%"
                                >
                                    {dateTo ? (
                                        <Text
                                            bold
                                            color="rgb(145, 152, 170)"
                                            align="center"
                                        >
                                            {moment(dateTo).format(
                                                this.uiDateFormat
                                            )}
                                        </Text>
                                    ) : (
                                        <FlexWrapper
                                            padding="0px"
                                            direction="row"
                                            align="space-around"
                                        >
                                            <Text>VIS TIL</Text>
                                            <Arrow
                                                block
                                                direction="down"
                                                margin="12px 10px 0px"
                                            />
                                        </FlexWrapper>
                                    )}
                                </Button>

                                <Button
                                    padding="10px 50px"
                                    margin="50px auto 10px"
                                    onClick={this.showData}
                                >
                                    VIS
                                </Button>
                            </Wrapper>
                        ) : (
                            <Wrapper>
                                <Header>
                                    <Text padding="0" size="x1" bold>
                                        Transaktioner fra:
                                    </Text>
                                    <TimeRange onClick={this.chooseNewDate}>
                                        <Icon
                                            margin="0 5px 0 0"
                                            color="#404757"
                                            src={calendarIcon}
                                            width="11px"
                                            height="13px"
                                        />
                                        {moment(dateFrom).format(
                                            this.uiDateFormat
                                        )}{' '}
                                        -{' '}
                                        {moment(dateTo).format(
                                            this.uiDateFormat
                                        )}
                                    </TimeRange>
                                </Header>
                                {data ? (
                                    data.length > 0 ? (
                                        data.map((item, index) => (
                                            <Row key={index}>
                                                <Col>
                                                    <Text
                                                        padding={
                                                            detectMobile()
                                                                ? '1px 0'
                                                                : '10px 0'
                                                        }
                                                        size="x05"
                                                    >
                                                        {item.text}
                                                    </Text>
                                                    {detectMobile() ? (
                                                        <Text
                                                            padding="1px 0 10px 0"
                                                            size="x05"
                                                        >
                                                            {moment(
                                                                item.transactionDate
                                                            ).format(
                                                                this
                                                                    .uiDateFormat
                                                            )}
                                                        </Text>
                                                    ) : null}
                                                </Col>
                                                {!detectMobile() ? (
                                                    <Col>
                                                        <Text
                                                            padding="10px 0"
                                                            size="x05"
                                                        >
                                                            {moment(
                                                                item.transactionDate
                                                            ).format(
                                                                this
                                                                    .uiDateFormat
                                                            )}
                                                        </Text>
                                                    </Col>
                                                ) : null}
                                                <Col>
                                                    <Text size="x05">
                                                        {item.amount} DKK
                                                    </Text>
                                                </Col>
                                                <Col>
                                                    <Text size="x05">
                                                        {item.balance} DKK
                                                    </Text>
                                                </Col>
                                            </Row>
                                        ))
                                    ) : (
                                        <Wrapper>Ingen data fundet</Wrapper>
                                    )
                                ) : (
                                    <ViewSpinner />
                                )}
                                {shouldShowMore ? (
                                    <Button
                                        margin="10px auto"
                                        round="10px"
                                        width="100%"
                                        onClick={this.showMore}
                                    >
                                        Vis mere
                                    </Button>
                                ) : null}
                            </Wrapper>
                        )}
                    </Wrapper>
                    <TextWrapper>
                        <Text>
                            For en fuld transaktionsoversigt, eller en liste af
                            transaktioner for et givet tidsrum bedes du rette
                            henvendelse til vores{' '}
                            <StyledLink onClick={() => window.Intercom('show')}>
                                kundeservice.
                            </StyledLink>
                        </Text>
                    </TextWrapper>

                    {this.state.datePicker}
                </FullScreen>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}

function mapDispatchToProps(dispatch) {
    return {
        authActions: bindActionCreators(AuthActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BetalingshistorikPage);
